import { useState, useEffect } from 'react';
import { sanitizeForLog } from '../utils/sanitize';

export function useLocalStorage<T>(key: string, initialValue: T) {
  const [storedValue, setStoredValue] = useState<T>(() => {
    try {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      console.error(`Error reading localStorage key "${sanitizeForLog(key)}":`, sanitizeForLog(error instanceof Error ? error.message : String(error)));
      return initialValue;
    }
  });

  const setValue = (value: T | ((val: T) => T)) => {
    try {
      const valueToStore = value instanceof Function ? value(storedValue) : value;
      setStoredValue(valueToStore);
      window.localStorage.setItem(key, JSON.stringify(valueToStore));
    } catch (error) {
      console.error(`Error setting localStorage key "${sanitizeForLog(key)}":`, sanitizeForLog(error instanceof Error ? error.message : String(error)));
    }
  };

  return [storedValue, setValue] as const;
}